(function () {
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initSection(section) {
    var revealables = section.querySelectorAll("[data-fvb-reveal]");

    revealables.forEach(function (item, index) {
      item.style.transitionDelay = Math.min(index * 90, 420) + "ms";
    });

    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealables.forEach(function (item) {
        item.classList.add("fvb-is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add("fvb-is-visible");
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.16,
        rootMargin: "0px 0px -40px 0px"
      }
    );

    revealables.forEach(function (item) {
      observer.observe(item);
    });
  }

  function init() {
    document.querySelectorAll("[data-fvb-section]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-fvb-section]");

    if (section) {
      initSection(section);
    }
  });
})();
